import { createContext } from 'react';
const RecordingContext = createContext();
export default RecordingContext;
